import { useState } from 'react'
import { message } from 'core/components/ui'
import RequesterTradeIn, { RequesterTradeInMethods } from 'core/requesters/RequesterTradeIn'

const useGetCar = props => {
  const { redirectMessage } = props

  const [car, setCar] = useState(null)
  const [carColors, setCarColors] = useState(null)
  const [carDesigns, setCarDesigns] = useState(null)
  const [carOptions, setCarOptions] = useState(null)

  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingDesign, setLoadingDesign] = useState(false)

  const [loadingParamsDefaults, setLoadingParamsDefaults] = useState(false)
  const [paramsDefaults, setParamsDefaults] = useState([])
  const [paramsFinancingQuestion, setParamsFinancingQuestion] = useState([])
  const [paramsTyresTypeQuestion, setParamsTyresTypeQuestion] = useState([])
  const [referencesTrailerHitches, setReferencesTrailerHitches] = useState([])

  const [loadingOthersDefaults, setLoadingOthersDefaults] = useState(false)
  const [othersDefaults, setOthersDefaults] = useState([])
  const [loadingSaddleryDefaults, setLoadingSaddleryDefaults] = useState(false)
  const [saddleryDefaults, setSaddleryDefaults] = useState([])
  const [defaults, setDefaults] = useState([])

  const getDefaults = params => {
    setLoading(true)
    RequesterTradeIn.get(RequesterTradeInMethods.GET_DAMAGES_ESTIMATED, params, redirectMessage)
      .then(datas => {
        setDefaults(datas.section)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getOthersDefaults = params => {
    setLoadingOthersDefaults(true)
    RequesterTradeIn.get(RequesterTradeInMethods.GET_DAMAGES_ESTIMATED, params, redirectMessage)
      .then(datas => {
        setOthersDefaults(datas.section)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setLoadingOthersDefaults(false)
      })
  }

  const getSaddleryDefaults = params => {
    setLoadingSaddleryDefaults(true)
    RequesterTradeIn.get(RequesterTradeInMethods.GET_DAMAGES_ESTIMATED, params, redirectMessage)
      .then(datas => {
        setSaddleryDefaults(datas.section)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setLoadingSaddleryDefaults(false)
      })
  }

  const getParamsDefaults = () => {
    setLoadingParamsDefaults(true)

    RequesterTradeIn.get(RequesterTradeInMethods.GET_PARAMS_FOR_DEFAULTS, {}, redirectMessage)
      .then(async datas => {
        setParamsDefaults(datas)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(() => {
        setLoadingParamsDefaults(false)
      })
  }

  const getParamsFinancingQuestion = () => {
    setLoading(true)
    setError(false)
    RequesterTradeIn.get(
      RequesterTradeInMethods.GET_PARAMS_FOR_FINANCING_QUESTION,
      {},
      redirectMessage
    )
      .then(async datas => {
        const { items } = datas

        setParamsFinancingQuestion(items)
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getParamsTyresTypeQuestion = () => {
    setLoading(true)
    setError(false)
    RequesterTradeIn.get(
      RequesterTradeInMethods.GET_PARAMS_FOR_TYRES_TYPE_QUESTION,
      {},
      redirectMessage
    )
      .then(async datas => {
        const { items } = datas

        setParamsTyresTypeQuestion(items)
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getReferencesTrailerHitches = () => {
    setLoading(true)
    setError(false)
    RequesterTradeIn.get(
      RequesterTradeInMethods.GET_REFERENCES_TRAILER_HITCHES,
      {},
      redirectMessage
    )
      .then(async datas => {
        const { items } = datas

        setReferencesTrailerHitches(items)
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getCarInformation = (params, originalCo2Emission) => {
    setError(false)
    setLoading(true)

    RequesterTradeIn.get(RequesterTradeInMethods.GET_CAR_INFORMATIONS, params, redirectMessage)
      .then(datas => {
        const { vehicleInformations } = datas
        setCar({
          ...vehicleInformations,
          co2Emission: !Number.isFinite(vehicleInformations.co2Emission)
            ? originalCo2Emission
            : vehicleInformations.co2Emission
        })
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getCarColors = params => {
    setError(false)
    setLoading(true)
    RequesterTradeIn.get(RequesterTradeInMethods.GET_COLORS, params, redirectMessage)
      .then(datas => {
        const { items } = datas

        setCarColors(items)
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getCarDesign = params => {
    setLoadingDesign(true)

    RequesterTradeIn.get(RequesterTradeInMethods.GET_DESIGN, params, redirectMessage)
      .then(datas => {
        const { leathers, fabrics, paints } = datas
        const type = paints.map(paint => ({
          ...paint,
          id: paint.id,
          label: paint.equipment,
          price: paint.inclVatPrice,
          serial: paint.serial
        }))

        const interior = {
          leathers: leathers.map(item => ({
            ...item,
            id: item.id,
            label: item.equipment,
            price: item.inclVatPrice,
            serial: item.serial
          })),
          fabrics: fabrics.map(item => ({
            ...item,
            id: item.id,
            label: item.equipment,
            price: item.inclVatPrice,
            serial: item.serial
          }))
        }

        const list = {
          exterior: {
            type
          },
          interior
        }
        setCarDesigns(list)
      })
      .catch(e => {
        message.error(e)
      })
      .finally(setLoadingDesign(false))
  }

  const getOptions = params => {
    setError(false)
    setLoading(true)
    RequesterTradeIn.get(RequesterTradeInMethods.GET_EQUIPMENTS, params, redirectMessage)
      .then(datas => {
        setCarOptions(datas)
      })
      .catch(() => {
        setError(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const resetErrorAndCar = () => {
    setError(false)
    setCar(null)
  }

  return {
    error,
    loading,
    getCarInformation,
    car,
    getCarColors,
    getCarDesign,
    carColors,
    carDesigns,
    getOptions,
    carOptions,
    getParamsDefaults,
    loadingParamsDefaults,
    paramsDefaults,
    getOthersDefaults,
    getSaddleryDefaults,
    loadingOthersDefaults,
    othersDefaults,
    loadingSaddleryDefaults,
    loadingDesign,
    saddleryDefaults,
    getDefaults,
    defaults,
    getParamsFinancingQuestion,
    paramsFinancingQuestion,
    getReferencesTrailerHitches,
    referencesTrailerHitches,
    getParamsTyresTypeQuestion,
    paramsTyresTypeQuestion,
    resetErrorAndCar
  }
}

export default useGetCar
